import { render } from "./Notes.vue?vue&type=template&id=dc5d3b9a&scoped=true&ts=true"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=dc5d3b9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5d3b9a"]])

export default __exports__